module.exports = __webpack_public_path__ + "static/media/frame.4f6ff0ea.svg";